export default __webpack_public_path__ + "static/media/travel-docs.1cee131f.svg";